import * as Constants from '../constants/ip-whitelist';

export const createIpWhitelist = ($http, ENV, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CREATE_IP_WHITELIST_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/2.0/third-party/white-list/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.CREATE_IP_WHITELIST_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_IP_WHITELIST_FAILED, payload: error });
        reject(error);
      });
  });

export const updateIpWhitelist = ($http, ENV, ipWhitelistId, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_IP_WHITELIST_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/third-party/white-list/${ipWhitelistId}/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_IP_WHITELIST_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_IP_WHITELIST_FAILED, payload: error });
        reject(error);
      });
  });

export const getIpWhitelist = ($http, ENV, ipWhitelistId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_IP_WHITELIST_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/third-party/white-list/${ipWhitelistId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_IP_WHITELIST_SUCCESS, payload: res.data['ip-white-list'] });
        resolve(res.data['ip-white-list']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_IP_WHITELIST_FAILED, payload: error });
        reject(error);
      });
  });

export const deleteIpWhitelist = ($http, ENV, ipWhitelistId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.DELETE_IP_WHITELIST_REQUEST });

    $http({
      method: 'DELETE',
      url: ENV.apiEndpoint + `/2.0/third-party/white-list/${ipWhitelistId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.DELETE_IP_WHITELIST_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.DELETE_IP_WHITELIST_FAILED, payload: error });
        reject(error);
      });
  });

export const setIpWhitelist = (data) => (dispatch) =>
  dispatch({ type: Constants.SET_IP_WHITELIST, payload: data });
